import apiClient from './apiClient'; // 기존에 설정된 axios client
import logger from '../utils/logger';

const fileService = {
  /**
   * 이미지 업로드
   * @param {File} file - 업로드할 파일 객체
   * @param {string} type - 업로드 용도 ('event', 'profile', 'business_card', 'chat')
   * @returns {Promise<{url: string, filename: string, success: boolean}>}
   */
  upload: async (file, type = 'event') => {
    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('type', type); // 백엔드로 용도 전달

      // 멀티파트 헤더 설정은 axios가 FormData 감지 시 자동으로 처리하지만,
      // 명시적 설정이 필요한 경우 apiClient 설정 확인 필요.
      const response = await apiClient.post('/upload/image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response; // axios interceptor가 data를 반환하도록 설정되어 있다면 response, 아니면 response.data
    } catch (error) {
      logger.error('❌ 파일 업로드 실패:', error);
      throw error;
    }
  }
};

export default fileService;